module.exports = __webpack_public_path__ + "img/minting-background-sm-2.6a4a00ef.png";